import {Component, Input} from '@angular/core';
import {Tooltip} from 'primeng/tooltip';
import {ServerTranslatePipe} from '@app/utils/pipes/server-translate-pipe';
import {FieldCropsColorPipe} from '@app/utils/pipes/field-crops-color-pipe';

@Component({
  selector: 'app-crops-name-colors',
  standalone: true,
  templateUrl: './crops-name-colors.html',
  imports: [
    Tooltip,
    ServerTranslatePipe,
    FieldCropsColorPipe
  ],
  styleUrl: './crops-name-colors.scss'
})
export class CropsNameColors {

  @Input({required: true}) crops: any;
  @Input() onlyColors = false;
  @Input() onlyNames = false;
}
